namespace $.$$ {

	export class $shm_service_workspace extends $.$shm_service_workspace {

		workspace_pages() {
			return [ this.task_list(), this.dashboard(), this.filters() ].filter( Boolean ) as $mol_view[]
		}

	}

}
